"use client"

import { ScrollArea } from "@ui/shad"

import { BulkEmailRecipientData, RecipientItem } from "./recipient-item"

interface RecipientListProps {
  recipients: BulkEmailRecipientData[]
  selectedRecipientId?: string
  onSelectRecipient?: (recipient: BulkEmailRecipientData) => void
}

export function RecipientList({ recipients, selectedRecipientId, onSelectRecipient }: RecipientListProps) {
  const recipientsWithEmail = recipients.filter((r) => r.email).length

  return (
    <div className="flex h-full flex-col">
      <div className="border-b px-4 py-2.5">
        <p className="text-sm font-medium">
          Recipients{" "}
          <span className="text-muted-foreground font-normal">
            ({recipientsWithEmail} / {recipients.length} have an email)
          </span>
        </p>
      </div>
      <ScrollArea className="flex-1">
        <div className="divide-y">
          {recipients.map((recipient) => (
            <RecipientItem
              key={`${recipient.type}-${recipient.id}`}
              recipient={recipient}
              isSelected={selectedRecipientId === recipient.id}
              isClickable={!!onSelectRecipient}
              onClick={() => onSelectRecipient?.(recipient)}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  )
}
